var map = {
	".": "1pD3",
	"./": "1pD3",
	"./03_get_deposit_hisrec": "dXH3",
	"./03_get_deposit_hisrec.json": "dXH3",
	"./04_get_withdraw_history": "kh23",
	"./04_get_withdraw_history.json": "kh23",
	"./05_post_wallets_coins": "zgmp",
	"./05_post_wallets_coins.json": "zgmp",
	"./06_post_wallets_withdraw": "YSKw",
	"./06_post_wallets_withdraw.json": "YSKw",
	"./13.get_wallet_queryDepositAddress": "rgh9",
	"./13.get_wallet_queryDepositAddress.json": "rgh9",
	"./14_get_risk_deposit_records": "CxZu",
	"./14_get_risk_deposit_records.json": "CxZu",
	"./index": "1pD3",
	"./index.js": "1pD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A7Vy";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/wallet ^.*$
// module id = A7Vy
// module chunks = 3